export default "__VITE_ASSET__AhmwdbUQ__"